import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";
import i18next from "i18next";
import { ContractStatusEnum, ContractStatusValue } from "./enum";

export const contractStatusItems: IFilterItemV2[] = [
  {
    key: ContractStatusEnum.NOT_SIGNED,
    value: ContractStatusValue.NOT_SIGNED,
    getLabel: () => i18next.t("filter.contractStatus.notSigned"),
  },
  {
    key: ContractStatusEnum.SIGNED,
    value: ContractStatusValue.SIGNED,
    getLabel: () => i18next.t("filter.contractStatus.signed"),
  },
  {
    key: ContractStatusEnum.ALL,
    value: undefined,
    getLabel: () => i18next.t("filter.all"),
  },
];
